import React, { useState } from 'react';
import { compose } from 'redux';
import { useSelector } from 'react-redux';
import { selectRenewMode } from '../../../redux/selectors/selectedCategoriesSelector';

import Form from '../MainForm';
import InputRadio from '../InputRadio';
import { Row } from '../../Structure';
import {
  withSelectedCategoriesActions,
  withScreenActions,
} from '../../../hocs/withActions';
import {
  withCategoriesData,
  withScreenData,
  withShouldSubmit,
} from '../../../hocs/withData';
import CustomContentAndDropdown from '../../Dropdown';

const CategoriesForm = ({
  SaveCategoriesForm = () => {},
  SaveSelectedCategories = () => {},
  RenewCategories = () => {},
  CategoriesData = [],
  EnableSpinner = () => {},
}) => {
  const [formName, setFormName] = useState(useSelector(selectRenewMode));

  const handleSubmit = (event) => {
    event.preventDefault();
    EnableSpinner();
    SaveCategoriesForm();
  };

  const RenderCategoriesForm = () => {
    if (formName !== 'selected') {
      return null;
    }
    return (
      <>
        <h4 className="cat-title">Categories Selected:</h4>
        <CustomContentAndDropdown
          options={CategoriesData.cpcsCategories}
          searchBy="name"
          searchById="code"
          valueField="code"
        />
      </>
    );
  };

  const onChangeHandler = (name) => {
    if (name === 'all') {
      SaveSelectedCategories([]);
    }
    setFormName(name);
    RenewCategories(name);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <InputRadio
          name="categories"
          value="all"
          startChecked
          onChange={onChangeHandler}
          checked={formName === 'all'}
        >
          <strong>Renew All Categories and Endorsements</strong>
        </InputRadio>
      </Row>
      <Row>
        <InputRadio
          name="categories"
          value="selected"
          onChange={onChangeHandler}
          checked={formName === 'selected'}
        >
          <strong>Renew Selected Categories</strong>
        </InputRadio>
      </Row>
      <RenderCategoriesForm />
    </Form>
  );
};

export default compose(
  withSelectedCategoriesActions,
  withScreenData,
  withCategoriesData,
  withShouldSubmit,
  withScreenActions
)(CategoriesForm);
